import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { api } from "../_services/api.service";
import { Row, Col, Card, CardBody, Button } from "reactstrap";
import swal from "sweetalert";
import DropIn from "braintree-web-drop-in-react";
import Loader from "react-loaders";

const Braintree = ({ user, isNormalUser, history }) => {
  let [instance, setInstance] = useState(null);
  let [clientToken, setClientToken] = useState("");
  let [braintreePlans, setBraintreePlans] = useState([]);
  let [webAppUrl, setWebAppUrl] = useState("");
  let [selectedPlan, setSelectedPlan] = useState(null);
  let [userHasActivePlan, setUserHasActivePlan] = useState(false);
  let [activeSubscription, setActiveSubscription] = useState(null);
  let [braintreeError, setBraintreeError] = useState(false);
  let [combinedSubscriptionMessage, setCombinedSubscriptionMessage] = useState(
    ""
  );

  let [isLoadingPlans, setIsLoadingPlans] = useState(false);
  let [isBuying, setIsBuying] = useState(false);
  let [isCancelling, setIsCancelling] = useState(false);
  let [isLoadingSubscription, setIsLoadingSubscription] = useState(false);

  useEffect(() => {
    if (user && user.userID > 0) {
      setCombinedSubscriptionMessage(user.combinedSubscriptionMessage);

      setIsLoadingPlans(true);

      if (isNormalUser) {
        api.getBraintreePlans().then(
          (plansResp) => {
            setIsLoadingPlans(false);
            setBraintreePlans(plansResp);
            loadSubscription(plansResp, user.userID);
          },
          (err) => {
            setBraintreeError(true);
            setIsLoadingPlans(false);
          }
        );
      }

      api.getWebAppUrl().then((url) => {
        setWebAppUrl(url);
      });

      api.getBraintreeClientToken(user.userID).then(
        (ct) => {
          setClientToken(ct);
        },
        (err) => {
          setBraintreeError(true);
        }
      );
    }
  }, [user]);

  const loadSubscription = (plansResp, userId) => {
    setIsLoadingSubscription(true);
    api.getBraintreeActiveSubscriptions(userId).then(
      (data) => {
        setIsLoadingSubscription(false);
        if (data && data.subscription) {
          setActiveSubscription(data.subscription);
          setUserHasActivePlan(true);
          setSelectedPlan(data.plan);
          // let plans = [...plansResp];
          // plans.forEach(x => x.isSelected = false);
          // var p = plans.find(x => x.id == activeSubscriptions[0].planId);

          // if (p !== undefined) {
          //     p.isSelected = true;
          // }

          // setBraintreePlans(plans);
        }
      },
      (err) => {
        setIsLoadingSubscription(false);
        setBraintreeError(true);
      }
    );
  };

  const buy = async () => {
    try {
      if (selectedPlan != null) {
        setIsBuying(true);
        let result = await instance.requestPaymentMethod();
        let nonce = result.nonce;
        api
          .createBraintreeTransaction(
            user.email,
            nonce,
            selectedPlan.price,
            selectedPlan.id
          )
          .then(
            (data) => {
              setIsBuying(false);
              loadSubscription(braintreePlans, user.userID);
              updateSubscriptionMessage();
              showSuccessPopup();
            },
            (err) => {
              setBraintreeError(true);
              setIsBuying(false);
            }
          );
      } else {
        swal("Please select a plan first", {
          buttons: {
            ok: {
              text: "Ok",
              value: "ok",
              className: "btn-success",
            },
          },
          icon: "warning",
        });
      }
    } catch (err) {
      setBraintreeError(true);
      setIsBuying(false);
      console.log(err);
    }
  };

  const cancel = () => {
    swal({
      text: isNormalUser
        ? "Please confirm that you wish to cancel your subscription to Definitive Choice.  Your information will remain in your account in case you wish to re-instate your subscription."
        : "Please confirm that you wish to cancel your organization’s subscription to Definitive Choice.  Information specific to your users will remain in their accounts if they want to start a personal subscription.",
      icon: "warning",
      buttons: {
        ok: "Cancel Subscription",
        cancel: "Close",
      },
      dangerMode: true,
    }).then((val) => {
      if (val) {
        setIsCancelling(true);
        api.cancelSubscription(user.userID, activeSubscription.id).then(
          (data) => {
            setIsCancelling(false);

            window.location.reload(true);
          },
          (err) => {
            setIsCancelling(false);

            setBraintreeError(true);
          }
        );
      }
    });
  };

  const updateSubscriptionMessage = () => {
    api.getUserById(user.userID).then((u) => {
      setCombinedSubscriptionMessage(u.combinedSubscriptionMessage);
    });
  };

  const onDropinInstance = (inst) => {
    setInstance(inst);
  };

  const goToWebApp = () => {
    if (webAppUrl !== "") {
      window.location.href = webAppUrl;
    }
  };

  const showSuccessPopup = () => {
    swal({
      title: "Thank you for subscribing to Definitive Choice!",
      text: "Click 'Close' to go back to the subscription portal or Click 'Make Decisions' to use the app!",
      icon: "success",
      buttons: {
        close: { text: "Close", className: "btn-primary" },
        makeDecisions: { text: "Make Decisions!", className: "btn-primary" },
      },
      closeOnClickOutside: true,
      closeOnEsc: true,
    }).then(val => {
      if (val === "makeDecisions") goToWebApp();
    });
  }

  return (
    <Fragment>
      {user && !braintreeError && (
        <Card className="main-card mb-3">
          <CardBody>
            <Row>
              <Col md="12">
                <div className="card-title">Subscription Information</div>
                <div style={{ margin: "30px" }}>
                  {combinedSubscriptionMessage}
                </div>
                {clientToken == "" && <p>Loading...</p>}
                {clientToken != "" && (
                  <div>
                    {isLoadingSubscription && <p>Loading subscription...</p>}
                    {!isLoadingSubscription && userHasActivePlan && (
                      <div>
                        <h5>The following subscription is active for you:</h5>
                        <p>
                          <b>Start date: </b>
                          {new Date(
                            activeSubscription.firstBillingDate
                          ).toDateString()}
                        </p>
                        <p>
                          <b>Next billing date: </b>
                          {new Date(
                            activeSubscription.nextBillingDate
                          ).toDateString()}
                        </p>
                        {/* <p><b>Expires: </b>{!activeSubscription.neverExpires ? 'True' : 'False'}</p> */}
                      </div>
                    )}
                    {isLoadingPlans && <p>Loading plans...</p>}
                    {!isLoadingPlans && braintreePlans.length > 0 && (
                      <Row>
                        {braintreePlans.find((x) => x.periodType == 1) !==
                          undefined && (
                          <Col md="6">
                            <h5>
                              <b>Month</b>
                            </h5>
                            {braintreePlans
                              .filter((x) => x.periodType == 1)
                              .map((p) => {
                                return (
                                  <div
                                    style={{
                                      textAlign: "center",
                                      border:
                                        selectedPlan && selectedPlan.id === p.id
                                          ? "3px solid lightblue"
                                          : "1px solid lightgray",
                                      padding: "5px",
                                      margin: "5px",
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      if (!userHasActivePlan) {
                                        setSelectedPlan(p);
                                        // let plans = [...braintreePlans];
                                        // plans.forEach(x => x.isSelected = false);
                                        // let plan = plans.find(x => x.id == p.id);
                                        // plan.isSelected = true;
                                        // setBraintreePlans(plans);
                                      }
                                    }}
                                  >
                                    <h4>{p.type}</h4>
                                    <span>{p.description}</span>
                                    <h5>${p.price}</h5>
                                  </div>
                                );
                              })}
                          </Col>
                        )}
                        {braintreePlans.find((x) => x.periodType == 2) !==
                          undefined && (
                          <Col md="6">
                            <h5>
                              <b>Year</b>
                            </h5>
                            {braintreePlans
                              .filter((x) => x.periodType == 2)
                              .map((p) => {
                                return (
                                  <div
                                    style={{
                                      textAlign: "center",
                                      border:
                                        selectedPlan && selectedPlan.id === p.id
                                          ? "5px solid lightblue"
                                          : "1px solid lightgray",
                                      padding: "5px",
                                      margin: "5px",
                                      borderRadius: "5px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      if (!userHasActivePlan) {
                                        setSelectedPlan(p);
                                        // let plans = [...braintreePlans];
                                        // plans.forEach(
                                        //   (x) => (x.isSelected = false)
                                        // );
                                        // let plan = plans.find(
                                        //   (x) => x.id == p.id
                                        // );
                                        // plan.isSelected = true;
                                        // setBraintreePlans(plans);
                                      }
                                    }}
                                  >
                                    <h4>{p.type}</h4>
                                    <span>{p.description}</span>
                                    <h5>${p.price}</h5>
                                  </div>
                                );
                              })}
                          </Col>
                        )}
                      </Row>
                    )}
                    {!userHasActivePlan && (
                      <>
                        <DropIn
                          options={{
                            authorization: clientToken,
                          }}
                          onInstance={onDropinInstance}
                        />
                        <Button
                          color="primary"
                          onClick={buy}
                          disabled={isBuying}
                        >
                          Buy
                        </Button>
                      </>
                    )}
                    {activeSubscription !== null && (
                      <Button
                        color="danger"
                        onClick={cancel}
                        disabled={isCancelling}
                      >
                        Cancel Subscription
                      </Button>
                    )}
                    {activeSubscription !== null && (
                      <Button
                        color="primary"
                        style={{
                          marginLeft: "5px",
                          marginRight: "5px",
                        }}
                        onClick={goToWebApp}
                      >
                        Make Decisions!
                      </Button>
                    )}
                    {(isBuying || isCancelling) && (
                      <Loader
                        style={{ display: "inline-block" }}
                        type="ball-pulse"
                        active
                      />
                    )}
                  </div>
                )}
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
      {braintreeError && (
        <Card className="main-card mb-3">
          <CardBody>
            <Row>
              <Col md="12">
                <div className="card-title">
                  Something went wrong and we couldn't load the subscription
                  information at this moment.
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
    </Fragment>
  );
};

export default Braintree;
